import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {snackbarAction} from "../../../errors/SnackbarSlice";
import {IResetPasswordReject} from "./fetchResetPassword.types";

interface IResetPasswordArgs {
    key: string
    password: string
    password_confirm: string
}

export const fetchResetPassword = createAsyncThunk<void,
    IResetPasswordArgs, ThunkConfig<IResetPasswordReject>>(
        'auth/fetchResetPassword',
        async (args, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;
            try {
                const response = await extra.api.post(
                    `/auth/reset-password`,
                    {
                        key: args.key,
                        password: args.password,
                        password_confirm: args.password_confirm,
                    });

                if (!response.data.success) {
                    const codeKey = response.data.codeKey;

                    if (codeKey === 'NOT_VALID' || codeKey === 'RESET_SESSION_NOT_FOUND') {
                        return rejectWithValue({error: codeKey})
                    }

                    dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                    return rejectWithValue({error: 'INTERNAL_ERROR'});
                }
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                return rejectWithValue({error: 'INTERNAL_ERROR'});
            }
        },
    );
